<template>
  <div class="legend-outer">
    <div class="legend-item-wrapper" v-for="(item, index) in props.data" :key="index">
      <div class="legend-item" :style="{visibility: item.value > 0 ? 'visible' : 'hidden' }">
        <div class="marker" :style="{ borderColor: item.color }"></div>
        <div class="labels">
          <span
            :class="{ large: props.fontSize === 'large', medium: props.fontSize === 'medium' }"
            >{{ formatCurrency(item.value || 0, currentPrivacyMode === 'yes' && item.label !== 'Opportunity') }}</span
          >
          <span class="text">{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { formatCurrency, type IChartDataItem } from './common'
import { usePrivacyStore } from '@/stores'

interface IProps {
  data: IChartDataItem[]
  fontSize?: string
}

const props = defineProps<IProps>()

const privacyStore = usePrivacyStore()

const { currentPrivacyMode } = storeToRefs(privacyStore)
</script>

<style scoped>
.legend-outer {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.3125rem 0;
  width: 15rem;
  padding-left: 0.625rem;
  height: 6.5625rem;
}

.legend-item-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: start;
}

.legend-outer .legend-item {
  display: flex;
  align-items: start;
  justify-content: start;
  gap: 0.3125rem;
  font-size: var(--font-size-small);
  line-height: var(--font-size-small);
  min-width: fit-content;
  align-items: center;
  width: 6.25rem;
}

.legend-outer .legend-item .marker {
  width: 1.25rem;
  height: 1.25rem;
  display: block;
  border-radius: 0.625rem;
  border: 0.15625rem solid;
}

.legend-outer .legend-item .labels {
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 5rem;
}

.legend-outer .legend-item .labels .text {
  max-width: 5rem;
}

.legend-outer .legend-item .labels .medium {
  font-size: var(--font-size-body);
  line-height: var(--font-size-body);
}

.legend-outer .legend-item .labels .large {
  font-size: var(--font-size-body);
  line-height: 1.125rem;
  font-weight: 700;
  padding-top: 0.625rem;
}
</style>
